import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20241108-Rate-Sheet.pdf";
const date = "08.11.2024";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>
    <p>
      <strong>Summary of change</strong>
    </p>
    <p>
      <strong>
        Following the Monetary Policy Committee announcement on Thursday 07 November 2024, the Bank of England Base Rate
        has reduced from 5.00% to 4.75%.{" "}
      </strong>
    </p>
    <p>With effect from Friday 08 November 2024 the changes are as follows:</p>
    <ul>
      <li>All tracker rates will include the reduced Bank of England Base Rate.</li>
      <li>There are no changes to our Residential Standard Variable Rate or Buy to Let Standard Variable Rate.</li>
    </ul>
    <p>There are no other changes to any other interest rates.</p>
    <p>An updated mortgage rate sheet will be published on Friday 08 November 2024 to reflect these changes.</p>
  </NewsArticleLayout>
);

export default Article;
